module.exports = __webpack_public_path__ + "static/media/cyclelogos_checkmark.ba700723.svg";